import React, { FC, ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { UserTypes } from 'users'

import { useAuth } from './../../../store/authStore/authStore'

interface AuthGateProps {
    allowTo?: UserTypes | UserTypes[]
    fallback?: ReactElement
    noFallback?: boolean
}

const AuthGate: FC<AuthGateProps> = (props) => {
    const { children, allowTo, fallback, noFallback } = props

    const [{ isAuthenticated, user }] = useAuth()

    const hasAccess = () => {
        if (typeof allowTo === 'string') {
            return (
                isAuthenticated &&
                user.roles.some((allowedRole) => allowedRole === allowTo)
            )
        } else if (Array.isArray(allowTo)) {
            return (
                isAuthenticated &&
                user.roles.some(
                    (allowedRole) => allowTo.indexOf(allowedRole) !== -1
                )
            )
        } else {
            return isAuthenticated
        }
    }

    if (hasAccess()) return <>{children}</>
    if (noFallback) return null
    if (fallback) return <>{fallback}</>

    return <DefaultFallback />
}

const DefaultFallback = () => {
    const { t } = useTranslation()
    return <div>{t('access_denied')}</div>
}

export default AuthGate
